
import type {PropType} from 'vue';
import {defineComponent} from 'vue';
// import Icon from '@/components/Icon/Icon.vue';
import Icon from '../Icon/Icon.vue';
import type {SubMenuItem, TopMenuItem} from './types';
// import DropdownMenu from '@/components/DropdownMenu/DropdownMenu.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';

export default defineComponent({
  name: 'OxdNavigationLink',

  components: {
    'oxd-icon': Icon,
    'oxd-dropdown-menu': DropdownMenu,
  },

  props: {
    menuItem: {
      type: Object as PropType<TopMenuItem>,
      required: true,
    },
  },

  setup() {
    const onClickMenu = (
      $event: MouseEvent,
      item: TopMenuItem | SubMenuItem,
    ) => {
      if (
        !(item as TopMenuItem).children ||
        (item as TopMenuItem).children.length === 0
      ) {
        window.location.replace(item.url);
      } else {
        $event.preventDefault();
        $event.stopPropagation();
      }
    };

    return {
      onClickMenu,
    };
  },
});
